<template>
  <el-dialog
    :title="$t('shopSetting.deleteConfirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{ $t('shopSetting.deleteShopSettingConfirm') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button 
        type="primary" 
        @click="deleteShopSetting"
      >{{ $t('common.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deleteShopSetting } from '@/api/goods/shopSettingApi'

export default {
  name: 'DeleteShopSetting',
  data() {
    return {
      dialogVisible: false,
      deleteShopSettingInfo: {
        ssId: '',
        caId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.deleteShopSettingInfo = { 
        ssId: row.ssId,
        caId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteShopSettingInfo = {
        ssId: '',
        caId: ''
      }
    },
    async deleteShopSetting() {
      try {
        await deleteShopSetting(this.deleteShopSettingInfo)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>